import { render, staticRenderFns } from "./winners.page.vue?vue&type=template&id=072418d4"
import script from "./winners.page.vue?vue&type=script&lang=js"
export * from "./winners.page.vue?vue&type=script&lang=js"
import style0 from "./winners.page.vue?vue&type=style&index=0&id=072418d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports